/**
 * @generated SignedSource<<ee4842438cd43c4011c479bf644e0eef>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteJobCategoryMutation$variables = {
  id: string;
};
export type DeleteJobCategoryMutation$data = {
  readonly deleteJobCategory: {
    readonly id: string;
  } | null;
};
export type DeleteJobCategoryMutation = {
  response: DeleteJobCategoryMutation$data;
  variables: DeleteJobCategoryMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteJobCategoryMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "JobCategory",
        "kind": "LinkedField",
        "name": "deleteJobCategory",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteJobCategoryMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "JobCategory",
        "kind": "LinkedField",
        "name": "deleteJobCategory",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteRecord",
            "key": "",
            "kind": "ScalarHandle",
            "name": "id"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8bcd0fb19eb5758b18767fe464082beb",
    "id": null,
    "metadata": {},
    "name": "DeleteJobCategoryMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteJobCategoryMutation(\n  $id: ID!\n) {\n  deleteJobCategory(id: $id) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "e1d5bf3d9790077e5c050bd72d860f4b";

export default node;
